import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveFloat12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMoveFloat12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M11.376 6.853a.45.45 0 0 1-.429.47c-.54.026-.907-.254-1.146-.426-.26-.188-.392-.27-.583-.263-.174.006-.29.084-.524.26-.216.165-.547.427-1.048.43-.509.003-.846-.262-1.066-.428-.237-.18-.356-.257-.532-.262-.194-.005-.327.076-.578.255-.234.167-.589.434-1.11.435-.525 0-.88-.268-1.116-.435-.253-.18-.387-.26-.58-.255-.176.005-.293.083-.53.262-.218.165-.554.43-1.06.428a.45.45 0 1 1 .003-.9c.17 0 .284-.07.515-.245.213-.162.545-.43 1.046-.444.529-.015.888.25 1.128.42.257.183.393.27.592.27.199-.001.335-.087.59-.27.238-.17.596-.433 1.122-.42.503.012.837.28 1.052.443.232.175.347.247.518.246.168 0 .282-.073.51-.246.212-.16.54-.426 1.036-.443.537-.02.904.26 1.141.432.259.187.39.266.578.257a.45.45 0 0 1 .471.429M9.668 4.874a2.3 2.3 0 0 0-.354-.039h-.163a2.3 2.3 0 0 0-.43.06 2.958 2.958 0 0 0-5.49.006 2.35 2.35 0 0 0-.944-.033 3.86 3.86 0 0 1 3.69-2.727l.198.005a3.86 3.86 0 0 1 3.493 2.728m-.243 2.859a3.86 3.86 0 0 1-3.448 2.126l-.2-.005a3.86 3.86 0 0 1-3.253-2.128l.153-.112.014-.012.03.02c.181.13.626.474 1.278.574a2.944 2.944 0 0 0 3.95.007c.666-.092 1.11-.455 1.288-.591l.006-.005.028.02z"
            />
        </svg>
    );
}
export default memo(IconMoveFloat12);
